module.exports = __webpack_public_path__ + "img/hk.053d2b21.png";